
let React = require("react");

class Toast extends React.Component {

    constructor(){
        super();

        this.onClose = this.onClose.bind(this);
    }
    componentDidUpdate(prevProps){
        if(this.props.show !== prevProps.show){
            if(this.props.resizeToastContainer) this.props.resizeToastContainer();
        }
    }
    
    onClose(){
        let {toastName, onClose} = this.props;
        onClose(toastName);
    }

    render() {
        let element;
        let { text, show = true, type = "successful", hasClose = true, icon = "toast__icon"} = this.props;

        if(text && text !== ""){
            element =  <p className="text"> {text} </p>;
        }else{
            element = this.props.children;
        }

        return  <div className={`toast ${show? "show": ""} ${type}`}>
                    <div className={`toast__icon ${icon}`}></div>
                    <div className="toast__body">
                        <div className="toast__body__container">{element}</div>
                        {hasClose && <button className="toast__body__close" onClick={this.onClose}></button>}
                    </div>
                </div>
    }
}

module.exports = Toast;
